import { Collapse, Icon, Select, Checkbox } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "use-lodash-debounce";
import AutoCompleteComponent from "../../../../common/components/AutoComplete";
import CardWhiteBlock from "../../../../common/components/CardWhite";
import ExaminationIntra from "../../../../common/components/Examination";
import LabelIcon from "../../../../common/components/LabelIcon";
import ScrollWrapper from "../../../../common/components/ScrollBar";
import { IntaOperationBody } from "../../../../common/components/icons/IntaOperation";
import { IntraOperationNewBody } from "../../../../common/components/icons/IntraOperationNew";
import {
  AtherectomyDirectionalIcon,
  AtherectomyLaserIcon,
  AtherectomyRotationalIcon,
  AtherectomyTransluminalIcon,
  BalloonIcon,
  BloodVesselPlaque0,
  BloodVesselPlaque100,
  BloodVesselPlaque20,
  BloodVesselPlaque40,
  BloodVesselPlaque60,
  BloodVesselPlaque80,
  BloodVesselPlaqueStent0,
  BloodVesselPlaqueStent100,
  BloodVesselPlaqueStent20,
  BloodVesselPlaqueStent40,
  BloodVesselPlaqueStent60,
  BloodVesselPlaqueStent80,
  IVUSIcon,
  StentBalloonCoveredIcon,
  StentBalloonIcon,
  StentCoveredIcon,
  StentIcon,
  UltrasoundProbeIcon,
  GradientIcon,
} from "../../../../common/components/icons/OperationIcon";
import { DevicesSVG, DugsSVG, ExpandSVG } from "../../../../common/components/icons/SVGIcon";
import { getArteryLabel } from "../../../../common/constants/Artery";
import { getMedical } from "../../../../common/constants/Operations";
import { getVeinLabel } from "../../../../common/constants/Vein";
import { getLocal } from "../../../../helpers/Local";
import { get_ai_recommendation, save_intra_answer, setChoiceAI } from "../../../../services/api.services";
import {
  HPIGetConditions,
  activeCheckTools,
  angioPatientSnapshotLoadInit,
  blockSaveIntra,
  getActiveStaff,
  getAngiographicSupplies,
  getAppointmentInventory,
  get_angio_type_variable,
  get_intra_answer,
  load_procedurals,
  resetListProcedurals,
  saveAppointmentInventory,
  save_info_side,
  save_intra_operative,
  save_procedurals,
  setActiveSaveIntraProps,
  setGlobalLoading,
  setGlobalToastr,
  setProcedureReview,
} from "../../../../store/actions";
import { SampleAccessData, StaticResource, filterMedicationsByQuery as filterDataByQuery } from "../../constant";
import AccessDetails from "../operativeDetailsComponents/AccessDetails";
import ArteryDetail from "../operativeDetailsComponents/ArteryDetail";
import VeinDetail from "../operativeDetailsComponents/VeinDetail";
import IntaOperativeSideBar from "./IntaOperativeSidebar";
import ProcedureSearch from "./procedureSearch";
import RemoveN from "src/helpers/RemoveN";
import CheckTools from "src/helpers/CheckTools";
import YesNo from "src/common/components/YesNo";
import EditableFormInput from "src/common/components/EditableText/EditableFormInput";
import ExtendDataTableNew from "src/common/components/SubDataTable/ExtendDataTableNew";
import ArteryDetailNewForAI from "../operativeDetailsComponents/ArteryDetailNewForAI";
import TestNewAI from "src/data/testNewAI";
import RuleKey from "src/data/RuleKey";

const { Panel } = Collapse;
const { Option } = Select;

let timer = null;

const ProcedureOptions = [
  "Right Lower Extremity Intervention",
  "Right Iliac Intervention",
  "Right Renal Artery Intervention",
  "Right Upper Extremity Intervention",
  "Right Innominate Artery Intervention",
  "Right PICC Line Placement",
  "Right Dialysis Catheter Placement",
  "Right Carotid Angiogram",
  "Right Dialysis Intervention",
  "Left Lower Extremity Intervention",
  "Left Iliac Intervention",
  "Left Renal Artery Intervention",
  "Left Upper Extremity Intervention",
  "Left Innominate Artery Intervention",
  "Left PICC Line Placement",
  "Left Dialysis Catheter Placement",
  "Left Carotid Angiogram",
  "Left Dialysis Intervention",
];

const titleStyle = {
  width: "25%",
  textAlign: "left",
  paddingLeft: "11px",
  color: "rgba(0, 0, 0, 0.65)",
  fontWeight: 600,
  borderLeft: "1px solid #dfe3e6",
  height: "100%",
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
};

// Inta Operation Data Structure
const SampleOperation = {
  body: "",
  medicals: [],
  details: [],
};

const IntaOperative = ({ data, title, dataCheckIntra, setCheckIfNoChangeIntra }) => {
  const collapseEndRef = useRef(null);
  const sidebarRef = useRef();
  const dispatch = useDispatch();
  const imageRef = useRef(null);
  const CPT = useSelector((state) => state.common.CPT);
  const stateActiveCheckTools = useSelector((state) => state.common.stateActiveCheckTools);
  const supplies = useSelector((state) => state.inventory.supplies);
  const appointmentInventories = useSelector((state) => state.procedure.inventories);
  const list_procedurals = useSelector((state) => state.procedure.list_procedurals);
  const allConditions = useSelector((state) => state.clinicProviderHPI.allConditions);
  const copy_intra_from_previous_visit = useSelector((state) => state.patientExamination.copy_intra_from_previous_visit);
  const is_locked = useSelector((state) => state.common.is_locked);
  const [scrollState, setScrollState] = useState(false);
  const [checkBoxState, setCheckBoxState] = useState({});
  const [group, setGroup] = useState("");
  const [dataShowResultHover, setDataShowResultHover] = useState([]);
  const [dataHoverGroup2, setDataHoverGroup2] = useState([]);
  const [getCollapseHeight, setGetCollapseHeight] = useState(0);
  const [activeSave, setActiveSave] = useState(false);
  const [stateErrors, setStateErrors] = useState({});
  const [allInventory, setAllInventory] = useState([]);
  const [itemNames, setItemNames] = useState([]);
  const [inventories, setInventories] = useState([]);
  const [inputInventory, setInputInventory] = useState("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [operationIndex, setOperationIndex] = useState(0);
  const [dataCheck, setDataCheck] = useState([]);
  const [isSidebar, setIsSidebar] = useState(true);
  const [disableDetail, setDisableDetail] = useState(true);
  const [loading, setLoading] = useState("");
  const [tab, setTab] = useState("documentation");
  const [bodyTab, setBodyTab] = useState("arterial");
  const [intaOperations, setIntaOperations] = useState([]);
  const [firstTime, setFirstTime] = useState(false);
  const [currentOperation, setCurrentOperation] = useState({
    ...SampleOperation,
  });
  const [selectedColumn, setSelectedColumn] = useState(-1);
  const [selectedOperation, setSelectedOperation] = useState("");
  const [dataCPTCode, setDataCPTCode] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const id_appoinment = getLocal("current_appointment_id");
  const debouncedSearch = useDebounce(inputInventory, 400);
  const [dataCPT, setDataCPT] = useState(null);
  const [isActiveTool, setIsActiveTool] = useState(true);
  const checkActiveAppointmentType = getLocal("checkActiveAppointmentType");
  const patient_id = getLocal("current_patient_id");
  const [isVenoGram, setIsVenoGram] = useState(false);
  const [disableCheckAtherectomy, setDisableCheckAtherectomy] = useState(false); // Peroneal, Trunc, Anterior, Tibial, Posterior, Peroneal will disable Atherectomy Required
  const [optimizedCombination, setOptimizedCombination] = useState([]);
  const [showProcedure, setShowProcedure] = useState([]);
  const [combinations, setCombinations] = useState([]);
  const [TestNewAILocal, setTestNewAILocal] = useState([]);
  const [activeCombination, setActiveCombination] = useState(-1);
  const [highest_net_profit, setHighest_net_profit] = useState(0);
  const [standardNetProfit, setStandardNetProfit] = useState(0);
  const [isEditingAi, setIsEditingAi] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [totalReimbursement, setTotalReimbursement] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [highlights, setHighlights] = useState([]);

  useEffect(() => {
    setTestNewAILocal(TestNewAI);
  }, []);

  useEffect(() => {
    dataCheckIntra && dataCheckIntra(dataCheck);
  }, [dataCheck]);

  useEffect(() => {
    if (checkActiveAppointmentType) {
      if (checkActiveAppointmentType == "active") {
        setIsActiveTool(false);
      } else {
        setIsActiveTool(true);
      }
    } else {
      setIsActiveTool(true);
    }
  }, [checkActiveAppointmentType]);

  useEffect(() => {
    setDataCPT(CPT);
  }, [CPT]);

  useEffect(() => {
    if (dataCPT && dataCPT?.appointment_type_id && !isActiveTool) {
      fetchListTypeAnswer(dataCPT?.appointment_type_id);
    }
  }, [dataCPT, isActiveTool]);

  const fetchListTypeAnswer = async (id) => {
    dispatch(get_angio_type_variable(id));
  };

  const fetchDetailAnswers = async () => {
    await dispatch(get_intra_answer(id_appoinment));
  };

  useEffect(() => {
    if (!isActiveTool) {
      fetchDetailAnswers();
    }
  }, [isActiveTool]);

  useEffect(() => {
    if (CPT && CPT?.angio_type?.name) {
      if (CPT?.angio_type?.name.includes("Venogram") || CPT?.angio_type?.name.includes("Venous")) {
        setBodyTab("vein");
        setIsVenoGram(true);
      } else {
        setBodyTab("arterial");
        setIsVenoGram(false);
      }
    }
  }, [CPT]);

  useEffect(() => {
    if (!firstTime) {
      setIntaOperations([]);
      //firstTime giúp chặn việc re render dữ liệu vì ở đây đang dùng redux map thẳng ra nên khi có gọi api nó sẽ load lại làm mất dữ liệu ở local
      // fix lỗi nếu product ngày trước không đc save giờ sẽ tự động map ra .. TODO
      const fixList = (list_procedurals || []).map((r) => {
        return {
          ...r,
          details: r?.details.map((detail, idx) => {
            const productCheck = (inventoryItems || []).find((product) => product?.name === detail?.product_description) || null;
            if (productCheck) {
              return {
                item: r?.medicals[idx] || null,
                ...detail,
                product: productCheck,
              };
            } else {
              return {
                item: r?.medicals[idx] || null,
                ...detail,
              };
            }
          }),
        };
      });
      setIntaOperations(fixList);
      if (fixList[0]) {
        setCurrentOperation(fixList[0]);
      } else {
        setCurrentOperation({ ...SampleOperation });
      }
    }
  }, [list_procedurals, inventoryItems]);

  const processVesselData = (input) => {
    const result = [...TestNewAI];

    input.forEach((item) => {
      let vesselName = item;
      let criterionToActivate = null;
      let activateVessel = false;

      // Check for modifiers
      if (item.endsWith("_exclude_stent")) {
        vesselName = item.replace("_exclude_stent", "");
        criterionToActivate = "Exclude Stent";
      } else if (item.endsWith("_atherectomy_required")) {
        vesselName = item.replace("_atherectomy_required", "");
        criterionToActivate = "Atherectomy Required";
      } else {
        vesselName = item;
      }
      activateVessel = true;

      // Find the vessel in the data
      const vessel = result.find((v) => v.vessel === vesselName);
      if (vessel) {
        // Set vessel active to true only for plain vessel names
        if (activateVessel) {
          vessel.active = true;
        }

        // If a criterion needs to be activated, update criteria
        if (criterionToActivate) {
          const criterion = vessel.criteria.find((c) => c.name === criterionToActivate);
          if (criterion) {
            criterion.active = true;
          }
        }
      }
    });

    return result;
  };

  const fetchAPIAI = async () => {
    dispatch(setGlobalLoading(true));
    const dataGet = await get_ai_recommendation(id_appoinment);
    setDataCPTCode(dataGet?.recommendations || []);
    // Peroneal, Trunc, Anterior, Tibial, Posterior, Peroneal will disable Atherectomy Required
    if (dataGet?.has_bcn || dataGet?.has_humana) {
      setDisableCheckAtherectomy(true);
    } else {
      setDisableCheckAtherectomy(false);
    }
    // set new data API
    if (dataGet?.ai_choice && Array.isArray(dataGet?.ai_choice)) {
      const dataVesselSuccess = processVesselData(dataGet?.ai_choice);
      setTestNewAILocal(dataVesselSuccess);
    } else {
      setTestNewAILocal([
        {
          active: false,
          vessel: "Common Iliac",
          criteria: [{ name: "Exclude Stent", active: false }],
        },
        {
          active: false,
          vessel: "External Iliac",
          criteria: [{ name: "Exclude Stent", active: false }],
        },
        {
          active: false,
          vessel: "Common Femoral",
          criteria: [
            { name: "Exclude Stent", active: false },
            { name: "Atherectomy Required", active: false },
          ],
        },
        {
          active: false,
          vessel: "SFA/Popliteal",
          criteria: [
            { name: "Exclude Stent", active: false },
            { name: "Atherectomy Required", active: false },
          ],
        },
        {
          active: false,
          vessel: "Tibioperoneal Trunk",
          criteria: [
            { name: "Exclude Stent", active: false },
            { name: "Atherectomy Required", active: false },
          ],
        },
        {
          active: false,
          vessel: "Anterior Tibial",
          criteria: [
            { name: "Exclude Stent", active: false },
            { name: "Atherectomy Required", active: false },
          ],
        },
        {
          active: false,
          vessel: "Posterior Tibial",
          criteria: [
            { name: "Exclude Stent", active: false },
            { name: "Atherectomy Required", active: false },
          ],
        },
        {
          active: false,
          vessel: "Peroneal",
          criteria: [
            { name: "Exclude Stent", active: false },
            { name: "Atherectomy Required", active: false },
          ],
        },
      ]);
    }
    setActiveCombination(-1);
    setOptimizedCombination(dataGet?.optimal_combination || []);
    setHighest_net_profit(dataGet?.highest_net_profit || 0);
    setStandardNetProfit(dataGet?.net_profit_standard || 0);
    setHighlights(dataGet?.highlights || []);
    setCombinations(dataGet?.combinations || []);
    setReasons(dataGet?.reasons || []);
    //
    const checkboxAPI = (dataGet?.ai_choice || []).reduce((obj, name) => {
      obj[name] = true;
      return obj;
    }, {});
    setCheckBoxState(checkboxAPI || {});

    dispatch(setGlobalLoading(false));
  };

  useEffect(() => {
    if (combinations && combinations.length > 0) {
      const optimalCombination = (combinations || []).find((item) => item.is_optimal);

      const totalReimbursement = optimalCombination?.total_reimbursement;
      const totalCost = optimalCombination?.total_cost;

      setTotalReimbursement(totalReimbursement);
      setTotalCost(totalCost);
    }
  }, [combinations]);

  useEffect(() => {
    if (activeCombination > -1) {
      const selectedCombination = combinations[activeCombination];
      setTotalReimbursement(selectedCombination?.total_reimbursement);
      setTotalCost(selectedCombination?.total_cost);
    } else if (activeCombination === -1) {
      if (combinations && combinations.length > 0) {
        const optimalCombination = (combinations || []).find((item) => item.is_optimal);

        const totalReimbursement = Number(optimalCombination?.total_reimbursement).toFixed(2);
        const totalCost = optimalCombination?.total_cost;

        setTotalReimbursement(totalReimbursement);
        setTotalCost(totalCost);
      }
    }
  }, [activeCombination]);

  useEffect(() => {
    dispatch(resetListProcedurals());
    fetchAPIAI();
    dispatch(getAngiographicSupplies("", "", 1));
    dispatch(getAppointmentInventory(id_appoinment));
    dispatch(angioPatientSnapshotLoadInit(id_appoinment));
    dispatch(load_procedurals(id_appoinment));
    dispatch(HPIGetConditions(id_appoinment));
    dispatch(getActiveStaff(""));
    if (window.innerWidth <= 768) {
      setIsSidebar(false);
    }
  }, [id_appoinment]);

  useEffect(() => {
    if (document.querySelector(".collapseParentt")) {
      const scrollContainer = document.querySelector(".collapseParentt").firstChild;
      const id = currentOperation?.body?.part;
      const panelHeight = 48;
      if (currentOperation?.body?.part) {
        const index = intaOperations
          .filter((r) => r?.body?.type !== "vein")
          .findIndex((operation) => {
            return operation?.body?.part === id;
          });
        const scrollHeight = panelHeight * index + 24;
        scrollContainer.scroll({
          top: scrollHeight,
          behavior: "smooth",
        });
      }
    }
  }, [currentOperation]);

  useEffect(() => {
    const temp_names = [];
    const temp_id = [];
    const temp_items = [];
    if (appointmentInventories && appointmentInventories.length > 0) {
      (appointmentInventories || []).map((item) => {
        if (!temp_names.some((r) => r === item?.name)) {
          temp_names.push(item?.name);
        }
        if (!temp_id.some((r) => r === item?.id)) {
          temp_id.push(item?.id);
        }
        temp_items.push(item);
      });
      setItemNames(temp_names);
      setInventories(temp_id);
      setInventoryItems(temp_items);
    } else {
      setItemNames(temp_names);
      setInventories(temp_id);
      setInventoryItems(temp_items);
    }
  }, [appointmentInventories]);

  useEffect(() => {
    if (debouncedSearch) {
      const allInventories = filterDataByQuery(supplies, debouncedSearch);
      setAllInventory(allInventories);
      setLoading(false);
    }
  }, [debouncedSearch]);

  const handleCloseSidebar = () => {
    setIsSidebar(false);
  };

  const removeStateTools = async () => {
    setCheckIfNoChangeIntra(true);
    setCurrentOperation({
      body: "",
      medicals: [],
      details: [],
    });
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(load_procedurals(id_appoinment));
    }, 300);
  };

  const handleInventorySearch = (search) => {
    setInputInventory(search);
    if (search) {
      setLoading(true);
    }
  };

  const selectItemInventory = (itemName, itemId) => {
    if (itemName === "") return;
    for (const itemId_ of inventories) {
      if (itemId_ === itemId) return;
    }
    const inventory = supplies.find((su) => su?.id === itemId);
    let listInventory = [...inventories];
    listInventory.push(itemId);
    setInventories(listInventory);
    dispatch(
      saveAppointmentInventory(id_appoinment, {
        inventory_id: listInventory,
      })
    );
    listInventory = [...itemNames];
    listInventory.push(itemName);
    setItemNames(listInventory);
    listInventory = [...inventoryItems];
    listInventory.push(inventory);
    dispatch(blockSaveIntra(true));
    setInventoryItems(listInventory);
    setCheckIfNoChangeIntra(true);
    setFirstTime(true);
  };

  useEffect(() => {
    const operationIndexCheck = intaOperations.findIndex((inta) => inta?.body?.part === currentOperation?.body?.part);
    setOperationIndex(operationIndexCheck);
  }, [currentOperation, intaOperations]);

  const removeRowIventory = (item, index) => {
    setCheckIfNoChangeIntra(true);
    let listItems = [...inventories];
    listItems.splice(index, 1);
    setInventories(listItems);
    dispatch(
      saveAppointmentInventory(id_appoinment, {
        inventory_id: listItems,
      })
    );
    listItems = [...itemNames];
    listItems.splice(index, 1);
    setItemNames(listItems);
    listItems = [...inventoryItems];
    listItems.splice(index, 1);
    dispatch(blockSaveIntra(true));
    setInventoryItems(listItems);
    setFirstTime(true);
  };

  const handleIntaOperation = (type) => (value) => {
    if (!isActiveTool) {
      return;
    }
    setCheckIfNoChangeIntra(true);
    if (!currentOperation?.body?.part && value.part && currentOperation?.medicals.length > 0) {
      setCurrentOperation({
        ...currentOperation,
        [type]: { ...value, type: bodyTab },
      });
      updateOperations({
        ...currentOperation,
        [type]: { ...value, type: bodyTab },
      });
    } else if (currentOperation?.body?.part && value.part === currentOperation?.body?.part) {
      setCurrentOperation({ ...currentOperation, [type]: { ...value, type: bodyTab } });
    } else if (currentOperation?.body?.part && value.part !== currentOperation?.body?.part) {
      const existingOperation = intaOperations.find((inta) => inta.body?.part === value.part);
      if (existingOperation) {
        setCurrentOperation(existingOperation);
      } else {
        setCurrentOperation({
          details: [],
          medicals: intaOperations.length > 0 ? [] : currentOperation?.medicals,
          [type]: { ...value, type: bodyTab },
        });
        if (!intaOperations.length && currentOperation?.medicals[0]) {
          updateOperations({
            details: [],
            medicals: currentOperation?.medicals,
            [type]: { ...value, type: bodyTab },
          });
        }
      }
    } else {
      setCurrentOperation({
        body: "",
        medicals: [],
        details: [],
        [type]: { ...value, type: bodyTab },
      });
    }
    setSelectedIndex(-1);
    setSelectedOperation("");
    setDisableDetail(true);
    setTab("tools");
  };

  const updateOperations = async (data) => {
    setCheckIfNoChangeIntra(true);
    const existing = intaOperations.findIndex((inta) => inta?.body?.part === data?.body?.part);
    const operations = [...intaOperations];
    if (existing === -1) {
      const isTibioperonealTrunk = data?.body?.part === "r-leg-5" || data?.body?.part === "l-leg-5";
      operations.push({
        ...data,
        body: { ...(data?.body || {}), type: bodyTab },
        ...(isTibioperonealTrunk && { separate_liaison: true }),
      });
    } else {
      operations[existing] = {
        ...data,
        body: { ...(data?.body || {}), type: bodyTab },
      };
    }
    let isArrayGreater = true;
    dispatch(setProcedureReview("intra_operations", operations));
    if (intaOperations.length < operations.length) isArrayGreater = true;
    else isArrayGreater = false;
    setIntaOperations(operations);
    setActiveSave(true);
    if (isArrayGreater) {
      if (getCollapseHeight) setGetCollapseHeight(0);
      let scrollHeightt = document.querySelector(".collapseParentt") ? document.querySelector(".collapseParentt").clientHeight : null;
      if (scrollHeightt) {
        setGetCollapseHeight(scrollHeightt);
        collapseEndRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  };

  const handleClickLabel = (value) => {
    if (!currentOperation?.body) {
      dispatch(
        setGlobalToastr({
          header: "Add fail!",
          message: "Please pick vein!",
          type: "failed",
        })
      );
      return;
    }
    setCheckIfNoChangeIntra(true);
    if (is_locked === false || is_locked === 0) {
      const current = { ...currentOperation };
      if (current.body && current?.body?.part) {
        current.medicals.push(value);
        current.details.push({
          body: getArteryLabel(current?.body?.part) || getVeinLabel(current?.body?.part),
          item: value,
        });
        updateOperations({ ...current });
      } else {
        current.medicals = [value];
        current.body = {
          offset: {
            screenX: 456,
            screenY: 704,
            x: 176,
            y: 341,
          },
          part: "m-body",
        };
        updateOperations({ ...current });
      }
      dispatch(blockSaveIntra(true));
      setFirstTime(true);
      setCurrentOperation(current);
      setScrollState(true);
      if (scrollState) setScrollState(false);
    }
  };

  const removeArrEmpty = (value, justOne) => {
    if (justOne) {
      const newArr = (value || []).filter((r) => r);
      return newArr;
    }
    const newArr = (value || []).map((r) => {
      return {
        ...r,
        details: (r?.details || []).filter((r) => r),
        medicals: (r?.medicals || []).filter((r) => r),
      };
    });
    return newArr;
  };

  /*
  @params value: artery name
  @params currentPosition: artery object include body, medicals, details
  @params medicalLabel: medical name of object that we want to move
  */

  const handleChangeArtery = (value, currentPosition, medicalLabel) => {
    if ((currentPosition == "l-neck-1" || currentPosition == "r-neck-1") && value !== "l-neck-1" && value !== "r-neck-1") {
      const indexRemoveIntra = intaOperations.findIndex((r) => r?.body?.part == currentPosition);
      if (indexRemoveIntra != -1 && intaOperations[indexRemoveIntra]) {
        intaOperations[indexRemoveIntra]["details"] = (intaOperations?.[indexRemoveIntra]?.["details"] || []).map((r) => {
          return {
            ...r,
            external_carotid_artery: null,
            intracranial_circulation: null,
          };
        });
        setIntaOperations([...removeArrEmpty(intaOperations)]);
        setActiveSave(true);
      }
    }
    setCheckIfNoChangeIntra(true);

    // Skip if is_locked is true
    if (is_locked === false || is_locked === 0) {
      // Normalize medical label
      let valueMedical = medicalLabel ? medicalLabel.toLowerCase() : "";
      valueMedical = valueMedical.replace(" ", "-").replace("%", "");

      // Find indices for current and target positions
      let positionRemove = intaOperations.findIndex((inta) => inta?.body?.part === currentPosition);
      let positionAdd = intaOperations.findIndex((inta) => inta?.body?.part === value);

      // If value is empty, remove the medical from current position
      if (!value || value === "") {
        if (positionRemove !== -1) {
          if (intaOperations?.[positionRemove]?.["medicals"] && Array.isArray(intaOperations?.[positionRemove]?.["medicals"])) {
            // Check if removing this medical leaves no medical data
            if (intaOperations[positionRemove]["medicals"].filter((r) => r !== valueMedical).length === 0) {
              intaOperations.splice(positionRemove, 1);
            } else {
              // Remove the specific medical and its detail by index
              intaOperations[positionRemove]["medicals"] = intaOperations[positionRemove]["medicals"].filter((r, index) => index !== selectedIndex);
              intaOperations[positionRemove]["details"] = intaOperations[positionRemove]["details"].filter((r, index) => index !== selectedIndex);
            }
            setIntaOperations([...removeArrEmpty(intaOperations)]);
          }
        }
        return;
      }

      // Get the medicals and details at the current position
      const currentMedicals = intaOperations?.[positionRemove]?.["medicals"] || [];
      const currentDetails = intaOperations?.[positionRemove]?.["details"] || [];
      const selectedMedicalIndex = selectedIndex;

      // Determine what to move: include "ivus" and any "stenosis-" entries immediately following
      let itemsToMove = [];
      let detailsToMove = [];
      let moveIndex = selectedMedicalIndex;

      // Always include the selected medical (e.g., "ivus")
      if (moveIndex < currentMedicals.length) {
        itemsToMove.push(currentMedicals[moveIndex]);
        detailsToMove.push(currentDetails[moveIndex]);
        moveIndex++;
      }

      // Check for "stenosis-" entries immediately following "ivus"
      while (moveIndex < currentMedicals.length && currentMedicals[moveIndex].startsWith("stenosis-")) {
        itemsToMove.push(currentMedicals[moveIndex]);
        detailsToMove.push(currentDetails[moveIndex]);
        moveIndex++;
      }

      // If target position (e.g., r-leg-4) already exists, append data
      if (positionAdd !== -1) {
        let destinationLocation = { ...intaOperations[positionAdd] };
        destinationLocation.body = {
          offset: {
            screenX: 456,
            screenY: 704,
            x: 176,
            y: 341,
          },
          part: value,
        };
        destinationLocation.medicals = removeArrEmpty([...(destinationLocation?.medicals || []), ...itemsToMove], true);
        destinationLocation.details = [...(destinationLocation?.details || []), ...detailsToMove];

        // Update current operation and intaOperations
        setCurrentOperation(destinationLocation);
        intaOperations[positionAdd] = destinationLocation;
        setIntaOperations([...removeArrEmpty(intaOperations)]);
        setActiveSave(true);

        updateOperations({ ...destinationLocation });
      } else {
        // If target position (e.g., r-leg-4) doesn't exist, create a new entry
        let newBodyPart = { ...currentOperation };
        newBodyPart.body = {
          offset: {
            screenX: 456,
            screenY: 704,
            x: 176,
            y: 341,
          },
          part: value,
        };
        newBodyPart.medicals = removeArrEmpty([...itemsToMove], true);
        newBodyPart.details = [...detailsToMove];
        setCurrentOperation(newBodyPart);
        intaOperations.push(newBodyPart);
        setIntaOperations([...removeArrEmpty(intaOperations)]);
        setActiveSave(true);
        updateOperations({ ...newBodyPart });
      }

      // Remove the moved medical and details from the current position (e.g., r-leg-7r)
      if (positionRemove !== -1) {
        if (intaOperations?.[positionRemove]?.["medicals"] && Array.isArray(intaOperations?.[positionRemove]?.["medicals"])) {
          // Filter out all moved items and their corresponding details
          intaOperations[positionRemove]["medicals"] = intaOperations[positionRemove]["medicals"].filter(
            (_, index) => index < selectedIndex || index >= moveIndex
          );
          intaOperations[positionRemove]["details"] = intaOperations[positionRemove]["details"].filter(
            (_, index) => index < selectedIndex || index >= moveIndex
          );

          // Check if current position has no remaining medical data
          if (intaOperations[positionRemove]["medicals"].length === 0) {
            intaOperations.splice(positionRemove, 1);
          }
          setIntaOperations([...removeArrEmpty(intaOperations)]);
          setActiveSave(true);

          setTab("tools");
        }
      }
    }
  };

  const handleSelectIcon = (value, index) => {
    setDisableDetail(false);
    setSelectedOperation(value);
    setSelectedIndex(index);
    setTab("details");
  };

  const handleCheckboxChange = async (vesselIndex, criteriaIndex = null) => {
    const updatedData = [...TestNewAILocal];
    setCheckIfNoChangeIntra(true);

    if (criteriaIndex !== null) {
      // Toggle the active state of the selected criterion
      updatedData[vesselIndex].criteria[criteriaIndex].active = !updatedData[vesselIndex].criteria[criteriaIndex].active;
    } else {
      // Toggle the active state of the vessel
      updatedData[vesselIndex].active = !updatedData[vesselIndex].active;

      // If vessel is set to false, set all criteria to false
      if (!updatedData[vesselIndex].active) {
        updatedData[vesselIndex].criteria = updatedData[vesselIndex].criteria.map((crit) => ({
          ...crit,
          active: false,
        }));
      }
    }
    setIsEditingAi(true);
    setTestNewAILocal(updatedData);
  };

  const dataOnchange = (value) => {
    if (is_locked === false || is_locked === 0) {
      setCheckIfNoChangeIntra(true);
      const operations = [...intaOperations];
      dispatch(setProcedureReview("intra_operations", operations));
      clearTimeout(timer);
      timer = setTimeout(() => {
        dispatch(
          save_info_side(id_appoinment, {
            ...value,
          })
        );
      }, 500);
    }
  };

  const handleRemoveMedical = (medical) => {
    setCheckIfNoChangeIntra(true);
    const current = { ...currentOperation };
    if (selectedIndex === -1) {
      setSelectedOperation("");
      setDisableDetail(true);
      setTab("tools");
      return;
    } else {
      current.medicals.splice(selectedIndex, 1);
      current.details.splice(selectedIndex, 1);
      setCurrentOperation(current);
      updateOperations(current);
      setSelectedOperation("");
      setDisableDetail(true);
      setSelectedIndex(-1);
      if (((!current.medicals || current.medicals.length == 0) && !current.details) || current.details.length == 0) {
        intaOperations.splice(operationIndex, 1);
        dispatch(setProcedureReview("intra_operations", intaOperations));

        setIntaOperations([...intaOperations]);
        setActiveSave(true);
      }
      setTab("tools");
    }
  };

  const handleMedicals = (medicals, from, to, details) => {
    setCheckIfNoChangeIntra(true);
    const params = { ...currentOperation, medicals, details };
    setCurrentOperation(params);
    updateOperations(params);
    setSelectedIndex(-1);
    setSelectedOperation("");
    setDisableDetail(true);
    setTab("tools");
  };

  const handleSeparateLesionChange = (operationIndex, checked) => {
    const operations = [...intaOperations];
    if (operations[operationIndex]) {
      operations[operationIndex].separate_liaison = checked;
      setIntaOperations(operations);
      dispatch(setProcedureReview("intra_operations", operations));
      setActiveSave(true);
    }
  };

  const saveCurrentOperation = (detail) => {
    setCheckIfNoChangeIntra(true);
    const current = { ...currentOperation };
    if (current.medicals[selectedIndex]) {
      if (detail.post_stenosis) {
        const curOperation = getMedical(current.medicals[selectedIndex]);
        if (curOperation) {
          const operation = current.medicals[selectedIndex + 1] ? getMedical(current.medicals[selectedIndex + 1]) : undefined;
          if (curOperation?.type !== "status" && !operation) {
            current.medicals[selectedIndex + 1] = "stenosis-" + detail.post_stenosis.replace("%", "");
            current.details[selectedIndex + 1] = [];
          } else if (curOperation?.type !== "status" && operation?.state && operation?.state === "stenosis") {
            current.medicals[selectedIndex + 1] = "stenosis-" + detail.post_stenosis.replace("%", "");
          } else if (curOperation?.type !== "status" && !operation?.state) {
            current.medicals.splice(selectedIndex + 1, 0, "stenosis-" + detail.post_stenosis.replace("%", ""));
            current.details.splice(selectedIndex + 1, 0, []);
          }
          if (curOperation?.type === "status") {
            current.medicals[selectedIndex] = curOperation?.state + "-" + detail.post_stenosis.replace("%", "");
          }
          current.details[selectedIndex] = detail;
          setCurrentOperation(current);
          updateOperations(current);
        }
        // Todo implement
      } else if (detail.stenosis) {
        const curOperation = getMedical(current.medicals[selectedIndex]);
        if (curOperation) {
          const operation = current.medicals[selectedIndex + 1] ? getMedical(current.medicals[selectedIndex + 1]) : undefined;
          if (curOperation?.type !== "status" && !operation) {
            current.medicals[selectedIndex + 1] = "stenosis-" + detail.stenosis.replace("%", "");
            current.details[selectedIndex + 1] = [];
          } else if (curOperation?.type !== "status" && operation?.state && operation?.state === "stenosis") {
            current.medicals[selectedIndex + 1] = "stenosis-" + detail.stenosis.replace("%", "");
          } else if (curOperation?.type !== "status" && !operation?.state) {
            current.medicals.splice(selectedIndex + 1, 0, "stenosis-" + detail.stenosis.replace("%", ""));
            current.details.splice(selectedIndex + 1, 0, []);
          }
          if (curOperation?.type === "status") {
            current.medicals[selectedIndex] = curOperation?.state + "-" + detail.stenosis.replace("%", "");
          }
          current.details[selectedIndex] = detail;
          setCurrentOperation(current);
          updateOperations(current);
        }
      } else {
        if (current.details[selectedIndex]) {
          current.details[selectedIndex] = detail;
          setCurrentOperation(current);
          updateOperations(current);
        }
      }
      // Todo implement
    }
  };

  const onHandleSaveAnswer = async (value) => {
    setCheckIfNoChangeIntra(true);
    const arrAnswers = [];
    (value || []).map((r) => {
      (r?.values || []).map((ans) => {
        if (ans?.checked) {
          arrAnswers.push({
            ...ans,
            question: r?.typeFull,
            checked_choice: ans?.option,
            comments: "",
            id_question: r?.id,
            angio_procedure_type_variable_id: r?.id,
          });
        } else {
          arrAnswers.push({
            ...ans,
            question: r?.typeFull,
            checked_choice: "",
            comments: "",
            id_question: r?.id,
            angio_procedure_type_variable_id: r?.id,
          });
        }
      });
    });
    // check to join arr checked
    const arrChecked = [];
    for (let index = 0; index < arrAnswers.length; index++) {
      const element = arrAnswers[index];
      if (
        (arrChecked && arrChecked?.length == 0) ||
        !arrChecked?.some((r) => r?.angio_procedure_type_variable_id === element?.angio_procedure_type_variable_id)
      ) {
        arrChecked.push({
          ...element,
        });
      } else {
        const indexId = arrChecked.findIndex((find) => find?.angio_procedure_type_variable_id === element?.angio_procedure_type_variable_id);
        if (indexId != -1) {
          arrChecked[indexId] = {
            ...arrChecked[indexId],
            checked_choice: `${arrChecked[indexId]["checked_choice"]},${element?.checked_choice}`,
          };
        }
      }
    }

    clearTimeout(timer);
    timer = setTimeout(async () => {
      dispatch(setGlobalLoading(true));
      await save_intra_answer(id_appoinment, {
        answers: arrChecked,
        appointment_id: Number(id_appoinment),
        angio_procedure_type_variable_id: (dataCPT && dataCPT["appointment_type_id"]) || 0,
      });
      await dispatch(get_intra_answer(id_appoinment));
      dispatch(setGlobalLoading(false));
    }, 300);
  };

  const handleSaveDocument = async () => {
    setCheckIfNoChangeIntra(true);
    dispatch(setGlobalLoading(true));
    if (dataCheck && dataCheck.length > 0) {
      const fixArr = (dataCheck || []).map((r) => {
        return {
          ...r,
          questions: (r?.questions || []).map((q) => {
            return {
              ...q,
              comments: RemoveN(q?.comments),
            };
          }),
        };
      });
      await dispatch(
        save_intra_operative(id_appoinment, {
          patient_id: patient_id,
          conditions: fixArr,
          copy_intra_from_previous_visit: copy_intra_from_previous_visit,
        })
      );
      setDataCheck(null);
    }
    dispatch(setGlobalLoading(false));
  };

  useEffect(() => {
    if (stateActiveCheckTools) {
      saveAll();
      dispatch(activeCheckTools(false));
    }
    return () => {
      dispatch(activeCheckTools(false));
    };
  }, [stateActiveCheckTools]);

  const toggleCheckboxState = (params, key, group) => {
    group.forEach((item) => {
      if (item !== key) {
        params[item] = false;
      }
    });
    return params;
  };

  const checkboxGroups = {
    "Anterior Tibial": ["Anterior Tibial_pta", "Anterior Tibial_pta_stent"],
    "Posterior Tibial": ["Posterior Tibial_pta", "Posterior Tibial_pta_stent"],
    Peroneal: ["Peroneal_pta", "Peroneal_pta_stent"],
    "Tibioperoneal Trunk": ["Tibioperoneal Trunk_pta", "Tibioperoneal Trunk_pta_stent"],
    "SFA/Popliteal": ["SFA/Popliteal_pta", "SFA/Popliteal_pta_stent"],
    "Common Femoral": ["Common Femoral_pta", "Common Femoral_pta_stent"],
    "External Iliac": ["External Iliac_pta", "External Iliac_pta_stent"],
    "Internal Iliac": ["Internal Iliac_pta", "Internal Iliac_pta_stent"],
    "Common Iliac": ["Common Iliac_pta", "Common Iliac_pta_stent"],
  };

  const handleCheckboxAI = async (e, key) => {
    const params = { ...checkBoxState, [key]: e.target.checked };
    //
    // "Anterior Tibial",
    // "Posterior Tibial",
    // "Peroneal",
    // "Tibioperoneal Trunk",
    // "SFA/Popliteal",
    // "Common Femoral Artery",
    // "External Iliac",
    // "Internal Iliac",
    // "Common Iliac",
    //
    Object.keys(checkboxGroups).forEach((group) => {
      if (checkboxGroups[group].includes(key)) {
        toggleCheckboxState(params, key, checkboxGroups[group]);
      }
    });

    const output = Object.entries(params || {})
      .filter(([_, value]) => value)
      .map(([key]) => key);

    setCheckBoxState(params);
  };

  const saveAiChoice = async () => {
    dispatch(setGlobalLoading(true));
    setIsEditingAi(false);
    const updatedData = [...TestNewAILocal];
    const returnValues = [];

    updatedData.map((vesselData) => {
      if (vesselData?.active) {
        returnValues.push(vesselData?.vessel);
      }
      if (vesselData["criteria"][0]?.active == true) {
        returnValues.push(`${vesselData?.vessel}_${vesselData.criteria[0]?.name.toLowerCase().replace(/\s+/g, "_")}`);
      }
      if (vesselData["criteria"][1]?.active == true) {
        returnValues.push(`${vesselData?.vessel}_${vesselData.criteria[1]?.name.toLowerCase().replace(/\s+/g, "_")}`);
      }
    });

    if (id_appoinment) {
      try {
        await setChoiceAI(id_appoinment, { ai_choice: returnValues || [] });
        fetchAPIAI();
        dispatch(setGlobalLoading(false));
        dispatch(
          setGlobalToastr({
            header: "OBL New AI optimization",
            message: "Save Successfully",
            type: "success",
          })
        );
      } catch (error) {
        dispatch(setGlobalLoading(false));
        dispatch(
          setGlobalToastr({
            header: "OBL New AI optimization",
            message: error,
            type: "failed",
          })
        );
      }
    }
  };

  const CheckboxGroup = ({ label, group }) => (
    <div className="resourceInfo between half-pannel" style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
      <div style={{ width: "calc(100% - 225px)" }}>{label}</div>
      {group.map((key) => (
        <Checkbox key={key} checked={checkBoxState[key] || false} onChange={(e) => handleCheckboxAI(e, key)} />
      ))}
    </div>
  );

  const renderCheckboxes = () => {
    return Object.keys(checkboxGroups).map((groupLabel, index) => (
      <CheckboxGroup key={index} label={groupLabel} group={checkboxGroups[groupLabel]} />
    ));
  };

  const saveAll = async () => {
    const errors = {};
    let isValid = true;
    for (let i = 0; i < intaOperations.length; i++) {
      if (intaOperations[i].details) {
        intaOperations[i].details.forEach((detail, indexDetail) => {
          if (detail?.body && Object.keys(detail).length > 1 && detail?.item) {
            const dataCheck = CheckTools.find((r) => r?.name.toLowerCase().includes(detail?.item.replace(/-/g, " ").toLowerCase()))?.require.forEach(
              (field) => {
                if (!detail[field]) {
                  isValid = false;
                  errors[`${detail?.body}`] = `${detail?.body} is required`;
                  const checkBalloonCoveredStent = detail?.item.toLowerCase();
                  errors[
                    `${intaOperations[i]["body"]["part"]}-${checkBalloonCoveredStent}-${indexDetail}`
                  ] = `${detail?.body} - ${detail?.item} have ${field} is required`;
                }
              }
            );
          } else if (detail?.body && Object.keys(detail).length == 1) {
            isValid = false;
            errors[`${detail?.body}`] = `${detail?.body} is required`;
          }
        });
      }
    }
    setStateErrors(errors);
    if (isValid) {
      dispatch(blockSaveIntra(false));
      dispatch(setActiveSaveIntraProps({ status: true, type: "" }));
      setActiveSave(false);
      // Save procedurals to API
      if (id_appoinment) {
        const operations = intaOperations && intaOperations.length > 0 ? intaOperations : [];
        await dispatch(
          save_procedurals(id_appoinment, {
            procedurals: operations.filter((r) => r.medicals && r.medicals.length > 0),
          })
        );
        dispatch(setProcedureReview("intra_operations", null));
      }
    } else {
      dispatch(
        setGlobalToastr({
          header: "Alert",
          type: "failed",
          message: errors,
        })
      );
      dispatch(setActiveSaveIntraProps({ status: false, type: "" }));
      dispatch(blockSaveIntra(true));
      setFirstTime(true);
    }
  };

  const getTitle = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            ...titleStyle,
            paddingLeft: "0",
            width: "20%",
            marginLeft: "3rem",
          }}
        >
          Vessel
        </div>
        <div
          style={{
            ...titleStyle,
            width: "calc(20% + 3rem)",
          }}
        >
          Criteria
        </div>
        <div
          style={{
            ...titleStyle,
            width: "50%",
          }}
        >
          Procedure Plan
        </div>
      </div>
    );
  };

  const renderPrice = () => {
    if (activeCombination > -1) {
      const priceAtCombination = combinations?.[activeCombination]?.["net_profit"]
        ? Number(combinations[activeCombination]["net_profit"] || 0).toFixed(2)
        : 0;
      const subtractedPrice = Number(priceAtCombination) - Number(standardNetProfit);
      return `${priceAtCombination} (${subtractedPrice.toFixed(2)})`;
    }

    const subtractedPrice = Number(highest_net_profit) - Number(standardNetProfit);

    //Hide the subtracted if highest net profit is 0
    if (Number(highest_net_profit) == 0) {
      return `${Number(highest_net_profit).toFixed(2)}`;
    }
    return `${Number(highest_net_profit).toFixed(2)} (${subtractedPrice.toFixed(2)})`;
  };

  const updateTestNewAI = (TestNewAI, RuleKey, apiKeys, type) => {
    let result = [];
    const checkedChoices = []; // Khai báo duy nhất checkedChoices
    console.log("TestNewAI", TestNewAI);

    // Trường hợp đặc biệt cho Tibioperoneal Trunk
    const tibioperonealTrunk = TestNewAI.find((item) => item.vessel === "Tibioperoneal Trunk" && item.active === true);
    const tibioExcludeStent = TestNewAI.find(
      (item) => item.vessel === "Tibioperoneal Trunk" && item.active === true && item.criteria[0]?.active === true
    );
    const tibioAtherectomyRequired = TestNewAI.find(
      (item) => item.vessel === "Tibioperoneal Trunk" && item.active === true && item.criteria[1]?.active === true
    );
    const tibioBoth = TestNewAI.find(
      (item) =>
        item.vessel === "Tibioperoneal Trunk" && item.active === true && item.criteria[0]?.active === true && item.criteria[1]?.active === true
    );
    const anteriorExcludeStent = TestNewAI.find(
      (item) => item.vessel === "Anterior Tibial" && item.active === true && item.criteria[0]?.active === true
    );
    const anteriorAtherectomyRequired = TestNewAI.find(
      (item) => item.vessel === "Anterior Tibial" && item.active === true && item.criteria[1]?.active === true
    );
    const anteriorBoth = TestNewAI.find(
      (item) => item.vessel === "Anterior Tibial" && item.active === true && item.criteria[0]?.active === true && item.criteria[1]?.active === true
    );
    const anteriorAlone = TestNewAI.find(
      (item) => item.vessel === "Anterior Tibial" && item.active === true && item.criteria[0]?.active === false && item.criteria[1]?.active === false
    );

    const posteriorExcludeStent = TestNewAI.find(
      (item) => item.vessel === "Posterior Tibial" && item.active === true && item.criteria[0]?.active === true
    );

    const posteriorAtherectomyRequired = TestNewAI.find(
      (item) => item.vessel === "Posterior Tibial" && item.active === true && item.criteria[1]?.active === true
    );

    const posteriorBoth = TestNewAI.find(
      (item) => item.vessel === "Posterior Tibial" && item.active === true && item.criteria[0]?.active === true && item.criteria[1]?.active === true
    );

    const posteriorAlone = TestNewAI.find(
      (item) => item.vessel === "Posterior Tibial" && item.active === true && item.criteria[0]?.active === false && item.criteria[1]?.active === false
    );

    const peronealExcludeStent = TestNewAI.find((item) => item.vessel === "Peroneal" && item.active === true && item.criteria[0]?.active === true);

    const peronealAtherectomyRequired = TestNewAI.find(
      (item) => item.vessel === "Peroneal" && item.active === true && item.criteria[1]?.active === true
    );

    const peronealBoth = TestNewAI.find(
      (item) => item.vessel === "Peroneal" && item.active === true && item.criteria[0]?.active === true && item.criteria[1]?.active === true
    );

    const peronealAlone = TestNewAI.find(
      (item) => item.vessel === "Peroneal" && item.active === true && item.criteria[0]?.active === false && item.criteria[1]?.active === false
    );

    const PosteriorTibial = TestNewAI.find((item) => item.vessel === "Posterior Tibial" && item.active === true);
    const Peroneal = TestNewAI.find((item) => item.vessel === "Peroneal" && item.active === true);
    const anterior = TestNewAI.find((item) => item.vessel === "Anterior Tibial" && item.active === true);
    const hasSFA = TestNewAI.some((item) => item.vessel === "SFA/Popliteal" && item.active === true);
    const hasCommonFemoralArtery = TestNewAI.some((item) => item.vessel === "Common Femoral" && item.active === true);

    //bây giờ phải xác định exception rule cho group B
    // nếu cpt là 37224 thì xem vessel nào có exclude stent thì apply vessel đó
    // nếu cpt là 37225 thì xem vessel nào có exclude stent và atherectomy required thì apply vessel đó, không có thì apply vessel nào có exclude stent
    // nếu cpt là 37226 thì xem vessel nào không có exclude stent và không có atherectomy required thì apply vessel đó
    // nếu cpt là 37227 thì apply vessel nào không có exclude stent và không có atherectomy required. nếu không thì apply vessel nào không có exclude stent và có atherectomy required
    if (apiKeys.includes("37224")) {
      if (hasSFA && hasCommonFemoralArtery) {
        // Nếu có cả SFA và Common Femoral Artery, ưu tiên SFA
        result.push({
          vessel: "SFA/Popliteal",
          code: 37224,
          value: "balloon-angioplasty",
        });
        checkedChoices.push("SFA/Popliteal");
      } else {
        for (let i = 0; i < TestNewAI.length; i++) {
          if (
            (TestNewAI[i].vessel === "Common Femoral" || TestNewAI[i].vessel === "SFA/Popliteal") &&
            !checkedChoices.includes(TestNewAI[i].vessel) // Kiểm tra vessel chưa được xử lý
          ) {
            if (TestNewAI[i]["active"] === true) {
              result.push({
                vessel: TestNewAI[i].vessel,
                code: 37224,
                value: "balloon-angioplasty",
              });
              checkedChoices.push(TestNewAI[i].vessel);
              break;
            }
          }
        }
      }
    }

    if (apiKeys.includes("37225")) {
      if (hasSFA && hasCommonFemoralArtery) {
        result.push({
          vessel: "SFA/Popliteal",
          code: 37225,
          value: "directional-atherectomy > balloon-angioplasty",
        });
        checkedChoices.push("SFA/Popliteal");
      } else {
        for (let i = 0; i < TestNewAI.length; i++) {
          if (
            (TestNewAI[i].vessel === "Common Femoral" || TestNewAI[i].vessel === "SFA/Popliteal") &&
            !checkedChoices.includes(TestNewAI[i].vessel)
          ) {
            if (TestNewAI[i]["active"] === true) {
              //vessel này có exclude stent và atherectomy required
              result.push({
                vessel: TestNewAI[i].vessel,
                code: 37225,
                value: "directional-atherectomy > balloon-angioplasty",
              });
              checkedChoices.push(TestNewAI[i].vessel);
              break;
            }
          }
        }
        const hasCode37225 = result.some((item) => item.code === 37225);
        if (!hasCode37225) {
          for (let i = 0; i < TestNewAI.length; i++) {
            if (
              (TestNewAI[i].vessel === "Common Femoral" || TestNewAI[i].vessel === "SFA/Popliteal") &&
              !checkedChoices.includes(TestNewAI[i].vessel)
            ) {
              if (TestNewAI[i]["active"] === true) {
                if (TestNewAI[i].criteria && TestNewAI[i].criteria[0] && TestNewAI[i].criteria[0]["active"] === true) {
                  // Vessel has exclude stent
                  result.push({
                    vessel: TestNewAI[i].vessel,
                    code: 37225,
                    value: "directional-atherectomy > balloon-angioplasty",
                  });
                  checkedChoices.push(TestNewAI[i].vessel);
                  break;
                } else {
                  result.push({
                    vessel: TestNewAI[i].vessel,
                    code: 37225,
                    value: "",
                  });
                }
              }
            }
          }
        }
      }
    }

    if (apiKeys.includes("37226")) {
      //nếu api có 37226, selection có SFA và Common Femoral Artery
      // thì cho tool nằm ở SFA
      if (hasSFA && hasCommonFemoralArtery) {
        result.push({
          vessel: "SFA/Popliteal",
          code: 37226,
          value: "balloon-angioplasty > self-expanding-stent",
        });
        checkedChoices.push("SFA/Popliteal");
      } else {
        // Nếu không có SFA và Common Femoral Artery, tìm vessel nào không có exclude stent và không có atherectomy required

        for (let i = 0; i < TestNewAI.length; i++) {
          if (
            (TestNewAI[i].vessel === "Common Femoral" || TestNewAI[i].vessel === "SFA/Popliteal") &&
            !checkedChoices.includes(TestNewAI[i].vessel)
          ) {
            if (TestNewAI[i]["active"] === true) {
              result.push({
                vessel: TestNewAI[i].vessel,
                code: 37226,
                value: "balloon-angioplasty > self-expanding-stent",
              });
              checkedChoices.push(TestNewAI[i].vessel);
              break;
            }
          }
        }
      }
    }

    if (apiKeys.includes("37227")) {
      //nếu api có 37227, selection có SFA và Common Femoral Artery
      // thì cho tool nằm ở SFA

      if (hasSFA && hasCommonFemoralArtery) {
        // Nếu có cả SFA và Common Femoral Artery, ưu tiên SFA
        result.push({
          vessel: "SFA/Popliteal",
          code: 37227,
          value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
        });
        checkedChoices.push("SFA/Popliteal");
      } else {
        for (let i = 0; i < TestNewAI.length; i++) {
          if (
            (TestNewAI[i].vessel === "Common Femoral" || TestNewAI[i].vessel === "SFA/Popliteal") &&
            !checkedChoices.includes(TestNewAI[i].vessel)
          ) {
            if (TestNewAI[i]["active"] === true) {
              //vessel này không có exclude stent và không có atherectomy required
              result.push({
                vessel: TestNewAI[i].vessel,
                code: 37227,
                value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
              });
              checkedChoices.push(TestNewAI[i].vessel);
              break;
            }
          }
        }
        const hasCode37227 = result.some((item) => item.code === 37227);
        if (!hasCode37227) {
          for (let i = 0; i < TestNewAI.length; i++) {
            if (
              (TestNewAI[i].vessel === "Common Femoral" || TestNewAI[i].vessel === "SFA/Popliteal") &&
              !checkedChoices.includes(TestNewAI[i].vessel)
            ) {
              if (TestNewAI[i]["active"] === true) {
                if (TestNewAI[i].criteria && TestNewAI[i].criteria[1] && TestNewAI[i].criteria[1]["active"] === true) {
                  //vessel này không có exclude stent
                  result.push({
                    vessel: TestNewAI[i].vessel,
                    code: 37227,
                    value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
                  });
                  checkedChoices.push(TestNewAI[i].vessel);
                  break;
                } else {
                  result.push({
                    vessel: TestNewAI[i].vessel,
                    code: 37227,
                    value: "",
                  });
                }
              }
            }
          }
        }
      }
    }

    if (tibioperonealTrunk) {
      //nếu có tibio và cpt optimization có 37231
      if (apiKeys.includes("37231")) {
        //Đây là trường hợp đặc biệt nếu tibio và posterior đi với nhau thì code 37231 return chỉ cho posterior
        // khi có code 37231 và tibio thì cần stop process hết các code trong group A
        if (posteriorAlone || posteriorAtherectomyRequired) {
          // nếu có posterior tibial
          result.push({
            vessel: "Posterior Tibial",
            code: 37231,
            value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
          });
        } else if (peronealAlone || peronealAtherectomyRequired) {
          // nếu có peroneal
          result.push({
            vessel: "Peroneal",
            code: 37231,
            value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
          });
        } else {
          // nếu ko có thì có thể là sẽ có anterior hay tibio
          if (anteriorAlone || anteriorAtherectomyRequired) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37231,
              value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
            });
          } else {
            result.push({
              vessel: "Tibioperoneal Trunk",
              code: 37231,
              value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
            });
          }
        }
      }

      if (apiKeys.includes("37230")) {
        if (posteriorAlone) {
          // nếu có posterior tibial
          result.push({
            vessel: "Posterior Tibial",
            code: 37230,
            value: "balloon-angioplasty > self-expanding-stent",
          });
        } else if (peronealAlone) {
          // nếu có peroneal
          result.push({
            vessel: "Peroneal",
            code: 37230,
            value: "balloon-angioplasty > self-expanding-stent",
          });
        } else {
          if (anteriorAlone) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37230,
              value: "balloon-angioplasty > self-expanding-stent",
            });
          } else {
            result.push({
              vessel: "Tibioperoneal Trunk",
              code: 37230,
              value: "balloon-angioplasty > self-expanding-stent",
            });
          }
        }
      }

      if (apiKeys.includes("37229")) {
        if (posteriorExcludeStent || posteriorAtherectomyRequired) {
          // nếu có posterior tibial
          result.push({
            vessel: "Posterior Tibial",
            code: 37229,
            value: "directional-atherectomy > balloon-angioplasty",
          });
        } else if (peronealExcludeStent || peronealAtherectomyRequired) {
          // nếu có peroneal
          result.push({
            vessel: "Peroneal",
            code: 37229,
            value: "directional-atherectomy > balloon-angioplasty",
          });
        } else {
          if (anteriorExcludeStent || anteriorAtherectomyRequired) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37229,
              value: "directional-atherectomy > balloon-angioplasty",
            });
          } else {
            result.push({
              vessel: "Tibioperoneal Trunk",
              code: 37229,
              value: "directional-atherectomy > balloon-angioplasty",
            });
          }
        }
      }

      if (apiKeys.includes("37228")) {
        if (posteriorExcludeStent) {
          // nếu có posterior tibial
          result.push({
            vessel: "Posterior Tibial",
            code: 37228,
            value: "balloon-angioplasty",
          });
        } else if (peronealExcludeStent) {
          // nếu có peroneal
          result.push({
            vessel: "Peroneal",
            code: 37228,
            value: "balloon-angioplasty",
          });
        } else {
          if (anteriorExcludeStent) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37228,
              value: "balloon-angioplasty",
            });
          } else {
            result.push({
              vessel: "Tibioperoneal Trunk",
              code: 37228,
              value: "balloon-angioplasty",
            });
          }
        }
      }

      // nếu có tibio và có 37235 nghĩa là có thể đã có 1 main và 1 sub artery
      // nếu mà là sub thì có khả năng là vô peroneal
      if (apiKeys.includes("37235")) {
        if (Peroneal) {
          const constHasNoPeroneal = !result.some((item) => item.vessel === "Peroneal");
          if (constHasNoPeroneal) {
            result.push({
              vessel: "Peroneal",
              code: 37235,
              value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
            });
          }
        }
        if (anterior) {
          // nếu có anterior
          const hasNoAnteriorTibial = !result.some((item) => item.vessel === "Anterior Tibial");
          if (hasNoAnteriorTibial) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37235,
              value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
            });
          }
        }
        if (PosteriorTibial) {
          const hasNoPosteriorTibial = !result.some((item) => item.vessel === "Posterior Tibial");
          if (hasNoPosteriorTibial) {
            result.push({
              vessel: "Posterior Tibial",
              code: 37235,
              value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
            });
          }
        } else {
          // nếu anterior đã có trong result rồi thì không cần thêm nữa
          result.push({
            vessel: "Tibioperoneal Trunk",
            code: 37235,
            value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
          });
        }
      }

      if (apiKeys.includes("37232")) {
        if (Peroneal) {
          const constHasNoPeroneal = !result.some((item) => item.vessel === "Peroneal");
          if (constHasNoPeroneal) {
            // nếu có peroneal
            result.push({
              vessel: "Peroneal",
              code: 37232,
              value: "balloon-angioplasty",
            });
          }
        }
        if (anterior) {
          // nếu có anterior
          const hasNoAnteriorTibial = !result.some((item) => item.vessel === "Anterior Tibial");
          if (hasNoAnteriorTibial) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37232,
              value: "balloon-angioplasty",
            });
          }
        }
        if (PosteriorTibial) {
          const hasNoPosteriorTibial = !result.some((item) => item.vessel === "Posterior Tibial");
          if (hasNoPosteriorTibial) {
            result.push({
              vessel: "Posterior Tibial",
              code: 37232,
              value: "balloon-angioplasty",
            });
          }
        } else {
          result.push({
            vessel: "Tibioperoneal Trunk",
            code: 37232,
            value: "balloon-angioplasty",
          });
        }
      }

      if (apiKeys.includes("37233")) {
        if (Peroneal) {
          const constHasNoPeroneal = !result.some((item) => item.vessel === "Peroneal");
          if (constHasNoPeroneal) {
            // nếu có peroneal
            result.push({
              vessel: "Peroneal",
              code: 37233,
              value: "directional-atherectomy > balloon-angioplasty",
            });
          }
        }
        if (anterior) {
          // nếu có anterior
          const hasNoAnteriorTibial = !result.some((item) => item.vessel === "Anterior Tibial");
          if (hasNoAnteriorTibial) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37233,
              value: "directional-atherectomy > balloon-angioplasty",
            });
          }
        }
        if (PosteriorTibial) {
          const hasNoPosteriorTibial = !result.some((item) => item.vessel === "Posterior Tibial");
          if (hasNoPosteriorTibial) {
            result.push({
              vessel: "Posterior Tibial",
              code: 37233,
              value: "directional-atherectomy > balloon-angioplasty",
            });
          }
        } else {
          result.push({
            vessel: "Tibioperoneal Trunk",
            code: 37233,
            value: "directional-atherectomy > balloon-angioplasty",
          });
        }
      }

      if (apiKeys.includes("37234")) {
        if (Peroneal) {
          // nếu có peroneal
          const constHasNoPeroneal = !result.some((item) => item.vessel === "Peroneal");
          if (constHasNoPeroneal) {
            result.push({
              vessel: "Peroneal",
              code: 37234,
              value: "balloon-angioplasty > self-expanding-stent",
            });
          }
        }
        if (anterior) {
          // nếu có anterior
          const hasNoAnteriorTibial = !result.some((item) => item.vessel === "Anterior Tibial");
          if (hasNoAnteriorTibial) {
            result.push({
              vessel: "Anterior Tibial",
              code: 37234,
              value: "balloon-angioplasty > self-expanding-stent",
            });
          }
        }
        if (PosteriorTibial) {
          const hasNoPosteriorTibial = !result.some((item) => item.vessel === "Posterior Tibial");
          if (hasNoPosteriorTibial) {
            result.push({
              vessel: "Posterior Tibial",
              code: 37234,
              value: "balloon-angioplasty > self-expanding-stent",
            });
          }
        } else {
          result.push({
            vessel: "Tibioperoneal Trunk",
            code: 37234,
            value: "balloon-angioplasty > self-expanding-stent",
          });
        }
      }
    }

    // Map through apiKeys
    // Check mỗi key trong optimal cpt combination
    apiKeys.forEach((key) => {
      if (key === "37224" || key === "37225" || key === "37226" || key === "37227") {
        return;
      }
      if (
        (key === "37231" ||
          key === "37229" ||
          key === "37228" ||
          key === "37230" ||
          key === "37232" ||
          key === "37233" ||
          key === "37234" ||
          key === "37235") &&
        tibioperonealTrunk
      ) {
        return;
      }
      // lấy rule của mỗi key -- ví dụ 37225 lả làm procedure tool gì
      const rule = RuleKey[key];
      if (rule && rule.check) {
        // Split the check string into individual vessels
        // check từ trong rule ra xem cpt này dùng cho vessel nào
        const vessels = rule.check
          .split(" / ")
          .map((v) => v.trim())
          .filter((v) => v);

        // Check each vessel in TestNewAI
        // lặp qua từng ai choice (vessel của user, nếu match với cpt code thì lấy procedure ra)
        for (let i = 0; i < TestNewAI.length; i++) {
          const item = TestNewAI[i];
          if (
            item.active &&
            vessels.includes(item.vessel) &&
            !checkedChoices.includes(item.vessel) // Kiểm tra vessel chưa được xử lý
          ) {
            checkedChoices.push(item.vessel); // Add the vessel to checked choices
            // Add object to result for active matching vessels
            result.push({
              vessel: item.vessel,
              code: Number(key),
              value: rule.value,
            });
            break; // Exit the loop once a match is found
          }
        }
      }
    });

    // Filter out results based on reasons
    if (reasons.includes("Patient has only claudication and tibial intervention not approved")) {
      result = result.filter(
        (item) =>
          (item.vessel !== "Tibioperoneal Trunk" && item.vessel !== "Peroneal" && item.vessel !== "Anterior Tibial") ||
          item.vessel !== "Posterior Tibial"
      );
    }

    return result;
  };
  const returnTools = () => {
    let updatedData = [];
    if (activeCombination === -1 && optimizedCombination && optimizedCombination.length > 0) {
      const apiKeys = (optimizedCombination || []).map((r) => `${r?.cpt_code?.code}`);
      updatedData = updateTestNewAI(TestNewAILocal, RuleKey, apiKeys, "optimizedCombinationKey");
    } else if (activeCombination > -1 && combinations?.[activeCombination]?.["combination"]) {
      updatedData = updateTestNewAI(TestNewAILocal, RuleKey, combinations?.[activeCombination]?.["combination"], "combinationsKey");
    } else {
      updatedData = [];
    }
    setShowProcedure(updatedData);
  };

  // Updated useEffect to pass necessary dependencies and avoid unnecessary re-renders
  useEffect(() => {
    returnTools();
  }, [activeCombination, optimizedCombination, combinations, RuleKey]);

  const renderProcedure = (index, optCheck) => {
    if (showProcedure && showProcedure.length > 0) {
      const valueData = showProcedure.find((row) => row?.vessel === optCheck?.vessel);
      const TextTools = valueData?.value;
      if (TextTools) {
        if (TextTools.includes(" > ")) {
          return {
            valueTools: TextTools.split(" > "),
            keyTools: valueData?.vessel,
          };
        } else {
          return {
            valueTools: TextTools.length > 0 ? [TextTools] : [],
            keyTools: valueData?.vessel,
          };
        }
      } else {
        return {
          valueTools: [],
          keyTools: valueData?.vessel,
        };
      }
    }
    return [];
  };

  const checkActiveDissable = (vessel) => {
    const paramsCheck = ["Tibioperoneal Trunk", "Anterior Tibial", "Posterior Tibial", "Peroneal"];
    if (paramsCheck.some((r) => r === vessel)) {
      return true;
    } else {
      return false;
    }
  };

  const checkHoverTibio = (data) => {
    // Check if Tibioperoneal Trunk is active
    const hasTibioTrunk = (data || []).some((item) => item.vessel === "Tibioperoneal Trunk" && item?.active === true);
    const hasAnteriorTibial = (data || []).some((item) => item.vessel === "Anterior Tibial" && item?.active === true);
    const hasPosteriorTibial = (data || []).some((item) => item.vessel === "Posterior Tibial" && item?.active === true);
    const hasPeroneal = (data || []).some((item) => item.vessel === "Peroneal" && item?.active === true);

    // Check if at least one of Anterior Tibial, Posterior Tibial, or Peroneal is active
    const hasAnyTibialOrPeroneal = hasAnteriorTibial || hasPosteriorTibial || hasPeroneal;

    // Define vessels that can have hoverActive: true
    const validVessels = ["Anterior Tibial", "Posterior Tibial", "Peroneal"];

    const dataValue = (data || []).map((item) => ({
      ...item,
      hoverActive:
        hasTibioTrunk && hasAnteriorTibial && hasAnyTibialOrPeroneal && validVessels.includes(item.vessel)
          ? // Set hoverActive to true only if the vessel is active for Anterior Tibial, Posterior Tibial, or Peroneal
            item.active === true
          : hasTibioTrunk &&
            !hasAnteriorTibial &&
            (hasPosteriorTibial || hasPeroneal) &&
            ["Posterior Tibial", "Peroneal", "Tibioperoneal Trunk"].includes(item.vessel)
          ? item.active === true
          : false,
    }));

    setDataShowResultHover(dataValue);
  };

  const checkHoverGroup2 = (data) => {
    // Check if SFA/Popliteal or Common Femoral Artery is active
    const hasSFA = (data || []).some((item) => item.vessel === "SFA/Popliteal" && item?.active === true);
    const hasCommonFemoralArtery = (data || []).some((item) => item.vessel === "Common Femoral" && item?.active === true);

    // Define vessels that can have hoverActive: true
    const validVessels = ["SFA/Popliteal", "Common Femoral"];

    const dataValue = (data || []).map((item) => ({
      ...item,
      hoverActive: hasSFA && hasCommonFemoralArtery && validVessels.includes(item.vessel) ? item.active : false,
    }));

    setDataHoverGroup2(dataValue);
  };

  useEffect(() => {
    checkHoverTibio(TestNewAILocal);
    checkHoverGroup2(TestNewAILocal);
  }, [TestNewAILocal]);

  return (
    <div className="clinicWorkflow__main-section">
      <div className="eventsContainer has-sub-header">
        <div className="patientContainer">
          <div className="imageSection" ref={imageRef} style={{ position: "relative" }}>
            <div
              className="tabHeaders new"
              style={{
                position: "absolute",
                top: "2rem",
                left: "calc(50% + 3rem)",
                transform: "translateX(-50%)",
              }}
            >
              {!isVenoGram && (
                <div
                  className={`tabHeaders-item
                 ${bodyTab === "arterial" ? "active" : ""}`}
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    setBodyTab("arterial");
                    removeStateTools("arterial");
                  }}
                >
                  Arterial Tree
                </div>
              )}
              {isVenoGram && (
                <div
                  className={`tabHeaders-item 
                  ${bodyTab === "vein" ? "active" : ""}`}
                  onClick={() => {
                    setBodyTab("vein");
                    removeStateTools("vein");
                  }}
                >
                  Vein Tree
                </div>
              )}
            </div>
            {bodyTab === "arterial" ? (
              <IntaOperationBody
                current={currentOperation}
                operations={intaOperations.filter((r) => r?.body?.type !== "vein")}
                handleClick={handleIntaOperation("body")}
              />
            ) : (
              <IntraOperationNewBody
                current={currentOperation}
                operations={intaOperations.filter((r) => r?.body?.type === "vein")}
                handleClick={handleIntaOperation("body")}
              />
            )}
          </div>
          <DndProvider backend={HTML5Backend}>
            <div className="detailSection" style={{ paddingRight: "10px" }}>
              <div className="tabHeaders new">
                <div
                  className={`tabHeaders-item ${tab === "documentation" ? "active" : ""}`}
                  style={{ textAlign: "left" }}
                  onClick={() => setTab("documentation")}
                >
                  Documentation
                </div>
                <div
                  className={`tabHeaders-item ${tab === "tools" ? "active" : ""} ${isActiveTool ? "" : "disabled"}`}
                  onClick={() => {
                    if (isActiveTool) {
                      handleSaveDocument();
                      setTab("tools");
                    }
                  }}
                >
                  Tools
                </div>
                <div
                  className={`tabHeaders-item ${tab === "details" ? "active" : ""} ${disableDetail && isActiveTool && "disabled"}`}
                  onClick={() => {
                    handleSaveDocument();
                    if (!disableDetail || !isActiveTool) {
                      setTab("details");
                    }
                  }}
                >
                  Details
                </div>
                <div
                  className={`tabHeaders-item ${tab === "inventory-utilization" ? "active" : ""}`}
                  onClick={() => {
                    handleSaveDocument();
                    setTab("inventory-utilization");
                  }}
                >
                  Inventory & Utilization
                </div>
                <div
                  className={`tabHeaders-item ${tab === "new_ai_optimization" ? "active" : ""}`}
                  onClick={() => {
                    handleSaveDocument();
                    setTab("new_ai_optimization");
                    fetchAPIAI();
                  }}
                >
                  AI Optimization
                </div>
              </div>
              {tab !== "new_ai_optimization" ? (
                <>
                  <CardWhiteBlock
                    varient={"default"}
                    title={""}
                    other={tab === "documentation" ? "full-height" : "half-height"}
                    cardContainerStyle={{
                      height: tab === "documentation" ? "100%" : "calc(50% - 1rem - 20px)",
                    }}
                    extraStyle={{
                      padding: tab === "documentation" ? "0px" : "0 1.5rem 1rem",
                      backgroundColor: tab === "documentation" ? "#f4f7fb" : "transparent",
                      height: "100%",
                    }}
                  >
                    {tab === "inventory-utilization" ? (
                      <div
                        className="content"
                        style={{
                          padding: "28px 1rem 12px",
                        }}
                      >
                        <AutoCompleteComponent
                          title="inta-operative"
                          placeholder="Search Inventory"
                          rows={itemNames}
                          disableDelete={is_locked}
                          keyLabel={"name"}
                          keyValue={"id"}
                          disableSearchIcon={false}
                          removeItem={removeRowIventory}
                          loading={loading}
                          options={allInventory}
                          isResult={false}
                          selectItem={selectItemInventory}
                          handleSearch={handleInventorySearch}
                          minRows={50}
                          isLocked={is_locked}
                          isIntraOperative={true}
                        />
                      </div>
                    ) : tab === "ai_optimization" ? (
                      <ScrollWrapper
                        css={`x-hidden
                    ${tab === "documentation" ? "no-padding" : "no-padding-obl"}
                  `}
                      >
                        <div
                          className="content"
                          style={{
                            padding: "24px 0px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                            }}
                          >
                            Which arterial segment has treatable lesions greater than 80%
                          </span>

                          <div style={{ marginTop: 10 }}>
                            <div
                              className="resourceInfo between half-pannel"
                              style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}
                            >
                              <div style={{ width: "20%" }}>Access</div>
                              <div style={{ width: "50%" }}>
                                <EditableFormInput
                                  label={"Access"}
                                  fullWidth={true}
                                  value={""}
                                  type="check"
                                  options={[
                                    { value: "Right Common Femoral" },
                                    { value: "Left Common Femoral" },
                                    { value: "Right Posterior Tibial" },
                                    { value: "Left Posterior Tibial" },
                                    { value: "Right Anterior Tibial" },
                                    { value: "Left Anterior Tibial" },
                                  ]}
                                  optionKey={"value"}
                                  valueKey={"value"}
                                  handleChange={(e) => {
                                    console.log(e);
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="resourceInfo between half-pannel"
                              style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}
                            >
                              <div style={{ width: "calc(100% - 180px)" }}></div>
                              <div>PTA</div>
                              <div>PTA - Stent</div>
                            </div>
                            {renderCheckboxes()}
                            <button
                              onClick={saveAiChoice}
                              disabled={is_locked}
                              className="common-btn"
                              style={{
                                float: "right", // Makes the button float to the right
                              }}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </ScrollWrapper>
                    ) : (
                      <ScrollWrapper
                        css={`x-hidden
                    ${tab === "documentation" ? "no-padding" : "no-padding-obl"}
                  `}
                      >
                        {tab === "documentation" && (
                          <div
                            className="content"
                            style={{
                              padding: "28px 0 12px",
                              height: `calc(${dataCheck && dataCheck.length <= 2 ? "160em" : "100em"} * ${
                                dataCheck && dataCheck.length > 1 ? dataCheck.length : 1
                              })`,
                            }}
                          >
                            <ProcedureSearch
                              disable={is_locked}
                              options={allConditions}
                              updateData={(data, status) => {
                                setDataCheck(data);
                                if (!status) {
                                  dispatch(blockSaveIntra(true));
                                  setFirstTime(true);
                                }
                              }}
                            />
                          </div>
                        )}
                        {tab === "indication" && (
                          <div className="content" style={{ padding: "28px 0 12px" }}>
                            <div className="info d-flex">
                              <Select
                                placeholder="Procedure to be Performed..."
                                suffixIcon={<ExpandSVG />}
                                allowClear={true}
                                style={{
                                  width: "25%",
                                  minWidth: "260px",
                                }}
                              >
                                {ProcedureOptions.map((opt, index) => (
                                  <Option key={`procedure-to-be-performed-${index}`} value={opt}>
                                    {opt}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                            <div className="info d-flex">
                              <Select
                                placeholder="Clinical Indication..."
                                suffixIcon={<ExpandSVG />}
                                allowClear={true}
                                style={{
                                  width: "25%",
                                  minWidth: "260px",
                                }}
                              >
                                <Option value="Critical Limb Ischemia">Critical Limb Ischemia</Option>
                                <Option value="Critical Limb Ischemia1">Critical Limb Ischemia</Option>
                              </Select>
                            </div>
                          </div>
                        )}
                        {tab === "tools" && (
                          <>
                            <Collapse className="card-collapse" accordion style={{ paddingTop: "12px", minHeight: "80%" }}>
                              <Panel header="Access" key="Access">
                                <div
                                  className="content"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <LabelIcon
                                    label={"Ultrasound"}
                                    isDraggable={true}
                                    icon={<UltrasoundProbeIcon />}
                                    item="ultrasound"
                                    handleClick={() => handleClickLabel("ultrasound")}
                                  />
                                  <LabelIcon
                                    label={"Local Anesthesia"}
                                    isDraggable={true}
                                    icon={<DugsSVG />}
                                    item="local-anesthesia"
                                    handleClick={() => handleClickLabel("local-anesthesia")}
                                  />
                                  <LabelIcon
                                    label={"Access"}
                                    isDraggable={true}
                                    icon={<DevicesSVG />}
                                    item="access"
                                    handleClick={() => handleClickLabel("access")}
                                  />
                                  <LabelIcon
                                    label={"Closure Device"}
                                    isDraggable={true}
                                    icon={
                                      <img
                                        src="/images/closure-featured.png"
                                        alt="closure device"
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                          marginLeft: 0,
                                          marginBottom: "5px",
                                        }}
                                      />
                                    }
                                    item="closure-device"
                                    handleClick={() => handleClickLabel("closure-device")}
                                  />
                                </div>
                              </Panel>
                              <Panel header="Diagnostic" key="Diagnostic">
                                <div
                                  className="content"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    flexWrap: "wrap",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <LabelIcon
                                    label={"Stenosis 0%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaque0 />}
                                    isHover={true}
                                    item="stenosis-0"
                                    active={!!currentOperation && currentOperation?.diagnostic === "stenosis-0"}
                                    handleClick={() => handleClickLabel("stenosis-0")}
                                  />
                                  <LabelIcon
                                    label={"Stenosis 20%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaque20 />}
                                    isHover={true}
                                    item="stenosis-20"
                                    active={!!currentOperation && currentOperation?.diagnostic === "stenosis-20"}
                                    handleClick={() => handleClickLabel("stenosis-20")}
                                  />
                                  <LabelIcon
                                    label={"Stenosis 40%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaque40 />}
                                    isHover={true}
                                    item="stenosis-40"
                                    active={!!currentOperation && currentOperation?.diagnostic === "stenosis-40"}
                                    handleClick={() => handleClickLabel("stenosis-40")}
                                  />
                                  <LabelIcon
                                    label={"Stenosis 60%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaque60 />}
                                    isHover={true}
                                    item="stenosis-60"
                                    active={!!currentOperation && currentOperation?.diagnostic === "stenosis-60"}
                                    handleClick={() => handleClickLabel("stenosis-60")}
                                  />
                                  <LabelIcon
                                    label={"Stenosis 80%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaque80 />}
                                    isHover={true}
                                    item="stenosis-80"
                                    active={!!currentOperation && currentOperation?.diagnostic === "stenosis-80"}
                                    handleClick={() => handleClickLabel("stenosis-80")}
                                  />
                                  <LabelIcon
                                    label={"Stenosis 100%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaque100 />}
                                    isHover={true}
                                    item="stenosis-100"
                                    active={!!currentOperation && currentOperation?.diagnostic === "stenosis-100"}
                                    handleClick={() => handleClickLabel("stenosis-100")}
                                  />
                                  <LabelIcon
                                    label={"In-Stent 0%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaqueStent0 />}
                                    isHover={true}
                                    item="in-stent-0"
                                    active={!!currentOperation && currentOperation?.diagnostic === "in-stent-0"}
                                    handleClick={() => handleClickLabel("in-stent-0")}
                                  />
                                  <LabelIcon
                                    label={"In-Stent 20%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaqueStent20 />}
                                    isHover={true}
                                    item="in-stent-20"
                                    active={!!currentOperation && currentOperation?.diagnostic === "in-stent-20"}
                                    handleClick={() => handleClickLabel("in-stent-20")}
                                  />
                                  <LabelIcon
                                    label={"In-Stent 40%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaqueStent40 />}
                                    isHover={true}
                                    item="in-stent-40"
                                    active={!!currentOperation && currentOperation?.diagnostic === "in-stent-40"}
                                    handleClick={() => handleClickLabel("in-stent-40")}
                                  />
                                  <LabelIcon
                                    label={"In-Stent 60%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaqueStent60 />}
                                    isHover={true}
                                    item="in-stent-60"
                                    active={!!currentOperation && currentOperation?.diagnostic === "in-stent-60"}
                                    handleClick={() => handleClickLabel("in-stent-60")}
                                  />
                                  <LabelIcon
                                    label={"In-Stent 80%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaqueStent80 />}
                                    isHover={true}
                                    item="in-stent-80"
                                    active={!!currentOperation && currentOperation?.diagnostic === "in-stent-80"}
                                    handleClick={() => handleClickLabel("in-stent-80")}
                                  />
                                  <LabelIcon
                                    label={"In-Stent 100%"}
                                    isDraggable={true}
                                    icon={<BloodVesselPlaqueStent100 />}
                                    isHover={true}
                                    item="in-stent-100"
                                    active={!!currentOperation && currentOperation?.diagnostic === "in-stent-100"}
                                    handleClick={() => handleClickLabel("in-stent-100")}
                                  />
                                  <LabelIcon
                                    label={"IVUS"}
                                    isDraggable={true}
                                    icon={<IVUSIcon />}
                                    isHover={true}
                                    item="ivus"
                                    active={!!currentOperation && currentOperation?.diagnostic === "ivus"}
                                    handleClick={() => handleClickLabel("ivus")}
                                  />
                                  <LabelIcon
                                    label={"Thrombus"}
                                    isDraggable={true}
                                    icon={<IVUSIcon />}
                                    isHover={true}
                                    item="thrombus"
                                    active={!!currentOperation && currentOperation?.diagnostic === "thrombus"}
                                    handleClick={() => handleClickLabel("thrombus")}
                                  />
                                  <LabelIcon
                                    label={"Dissection"}
                                    isDraggable={true}
                                    icon={<IVUSIcon />}
                                    isHover={true}
                                    item="dissection"
                                    active={!!currentOperation && currentOperation?.diagnostic === "dissection"}
                                    handleClick={() => handleClickLabel("dissection")}
                                  />
                                  <LabelIcon
                                    label={"Gradient"}
                                    isDraggable={true}
                                    icon={<GradientIcon />}
                                    isHover={true}
                                    item="gradient"
                                    active={!!currentOperation && currentOperation?.diagnostic === "gradient"}
                                    handleClick={() => handleClickLabel("gradient")}
                                  />
                                </div>
                              </Panel>
                              {bodyTab !== "vein" && (
                                <Panel header="Atherectomy" key="Atherectomy">
                                  <div
                                    className="content"
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      justifyContent: "flex-start",
                                      flexWrap: "wrap",
                                      paddingTop: "0.5rem",
                                    }}
                                  >
                                    <LabelIcon
                                      label={"Directional Atherectomy"}
                                      isDraggable={true}
                                      icon={<AtherectomyDirectionalIcon />}
                                      item="directional-atherectomy"
                                      handleClick={() => handleClickLabel("directional-atherectomy")}
                                    />
                                    <LabelIcon
                                      label={"Laser Atherectomy"}
                                      isDraggable={true}
                                      icon={<AtherectomyLaserIcon />}
                                      item="laser-atherectomy"
                                      handleClick={() => handleClickLabel("laser-atherectomy")}
                                    />
                                    <LabelIcon
                                      label={"Rotational Atherectomy"}
                                      isDraggable={true}
                                      icon={<AtherectomyRotationalIcon />}
                                      item="rotational-atherectomy"
                                      handleClick={() => handleClickLabel("rotational-atherectomy")}
                                    />
                                    <LabelIcon
                                      label={"Obital Atherectomy"}
                                      isDraggable={true}
                                      icon={<AtherectomyTransluminalIcon />}
                                      item="obital-atherectomy"
                                      handleClick={() => handleClickLabel("obital-atherectomy")}
                                    />
                                  </div>
                                </Panel>
                              )}
                              <Panel header="Angioplasty" key="Angioplasty">
                                <div
                                  className="content"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <LabelIcon
                                    label={"Balloon Angioplasty"}
                                    isDraggable={true}
                                    icon={<BalloonIcon />}
                                    item="balloon-angioplasty"
                                    handleClick={() => handleClickLabel("balloon-angioplasty")}
                                  />
                                </div>
                              </Panel>
                              <Panel header="Stenting" key="Stenting">
                                <div
                                  className="content"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    flexWrap: "wrap",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <LabelIcon
                                    label={"Balloon Expandable Covered Stent"}
                                    isDraggable={true}
                                    icon={<StentBalloonCoveredIcon />}
                                    item="balloon-expandable-covered-stent"
                                    handleClick={() => handleClickLabel("balloon-expandable-covered-stent")}
                                  />
                                  <LabelIcon
                                    label={"Covered Stent"}
                                    isDraggable={true}
                                    icon={<StentCoveredIcon />}
                                    item="covered-stent"
                                    handleClick={() => handleClickLabel("covered-stent")}
                                  />
                                  <LabelIcon
                                    label={"Balloon Expandable Stent"}
                                    isDraggable={true}
                                    icon={<StentBalloonIcon />}
                                    item="balloon-expandable-stent"
                                    handleClick={() => handleClickLabel("balloon-expandable-stent")}
                                  />
                                  <LabelIcon
                                    label={"Self Expanding Stent"}
                                    isDraggable={true}
                                    icon={<StentIcon />}
                                    item="self-expanding-stent"
                                    handleClick={() => handleClickLabel("self-expanding-stent")}
                                  />
                                </div>
                              </Panel>
                              <Panel header="Other" key="Other">
                                <div
                                  className="content"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <LabelIcon
                                    label={"Thrombectomy"}
                                    isDraggable={true}
                                    icon={<IVUSIcon />}
                                    isHover={true}
                                    item="thrombectomy"
                                    active={!!currentOperation && currentOperation?.diagnostic === "thrombectomy"}
                                    handleClick={() => handleClickLabel("thrombectomy")}
                                  />
                                  <LabelIcon
                                    label={"Lithotripsy"}
                                    isDraggable={true}
                                    icon={<AtherectomyTransluminalIcon />}
                                    isHover={true}
                                    item="lithotripsy"
                                    active={!!currentOperation && currentOperation?.diagnostic === "lithotripsy"}
                                    handleClick={() => handleClickLabel("lithotripsy")}
                                  />
                                </div>
                              </Panel>
                            </Collapse>
                            {activeSave ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: 50,
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-start",
                                }}
                              >
                                <button onClick={saveAll} disabled={is_locked} className="common-btn">
                                  Save
                                </button>
                              </div>
                            ) : null}
                          </>
                        )}
                        {tab === "details" && (
                          <>
                            {isActiveTool ? (
                              <AccessDetails
                                saveAll={saveAll}
                                handleChangeArtery={handleChangeArtery}
                                title={"19G Access"}
                                inventories={supplies}
                                items={inventoryItems}
                                data={SampleAccessData}
                                disable={is_locked}
                                current={currentOperation}
                                activeIndex={selectedIndex}
                                activeItem={selectedOperation}
                                handleSubmit={saveCurrentOperation}
                                removeItem={handleRemoveMedical}
                                isVenoGram={isVenoGram}
                              />
                            ) : (
                              <div
                                className="resourceContent"
                                style={{
                                  flex: "unset",
                                  margin: 0,
                                  padding: 0,
                                }}
                              >
                                <div
                                  className="resourceInfo"
                                  style={{
                                    paddingLeft: "0px",
                                    display: "block",
                                    paddingTop: 20,
                                  }}
                                >
                                  <ExaminationIntra
                                    type="procedure"
                                    saveAll={saveAll}
                                    onChangeData={(value) => {
                                      onHandleSaveAnswer(value);
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </ScrollWrapper>
                    )}
                  </CardWhiteBlock>
                  <CardWhiteBlock
                    varient={"default"}
                    cardContainerStyle={{
                      height: "calc(50% - 20px)",
                      padding: "0 1.5rem 1rem",
                      marginBottom: 0,
                    }}
                    extraStyle={{
                      height: "calc(100% - 2.8rem)",
                      paddingBottom: 0,
                    }}
                    title={
                      <div
                        className="pannel-title"
                        style={{
                          marginTop: "1.5rem",
                          marginLeft: "-12px",
                          display: "flex",
                        }}
                      >
                        <Icon type="appstore" theme="twoTone" twoToneColor="#EE5396" />
                        <span
                          style={{
                            marginLeft: "8px",
                            fontSize: "18px",
                            fontWeight: "normal",
                          }}
                        >
                          PROCEDURAL DOCUMENTATION
                        </span>
                      </div>
                    }
                    other={tab === "documentation" ? "d-none" : "half-height"}
                  >
                    <ScrollWrapper css="no-padding-procedural x-hidden collapseParentt">
                      {
                        <Collapse
                          className="card-collapse bodyPart_parent"
                          accordion
                          style={{ paddingTop: "24px" }}
                          activeKey={currentOperation?.body?.part ? `${currentOperation?.body?.part} - ${operationIndex}` : undefined}
                          onChange={(panelKey) => {
                            if (panelKey) {
                              const part = panelKey.split(" - "); // Extract part from key
                              const operation = part[0] ? intaOperations.find((inta) => inta?.body?.part === part[0]) : null;
                              if (operation && panelKey !== `${currentOperation?.body?.part} - ${operationIndex}`) {
                                setCurrentOperation(operation);
                                setOperationIndex(part[1] || -1);
                                setDisableDetail(true);
                                setSelectedOperation("");
                                setSelectedIndex(-1);
                                setTab("tools");
                              }
                            } else {
                              setCurrentOperation({
                                ...SampleOperation,
                                body: "",
                                medicals: [],
                              });
                              setDisableDetail(true);
                              setSelectedOperation("");
                              setSelectedIndex(-1);
                              setTab("tools");
                            }
                          }}
                        >
                          {bodyTab === "arterial"
                            ? (intaOperations.filter((r) => r?.body?.type !== "vein") || []).map((operation, index, arr) => {
                                return (
                                  <Panel
                                    header={getArteryLabel(operation?.body?.part)}
                                    key={`${operation?.body?.part} - ${index}`}
                                    id={`panel-${operation?.body?.part}-${index}`}
                                    className={
                                      operation.details.some((checkError) => stateErrors?.[checkError?.body])
                                        ? "error-validation"
                                        : [arr.length - 1].includes(index)
                                        ? `secondLastPanel`
                                        : ""
                                    }
                                  >
                                    
                                    <ArteryDetail
                                      stateErrors={stateErrors}
                                      data={operation?.body}
                                      medicals={operation?.medicals.map((r) => r && r.replace(" ", "-"))}
                                      details={operation?.details}
                                      diagnostic={operation?.diagnostic}
                                      medical={operation?.medical}
                                      handleOperation={handleSelectIcon}
                                      handleMedicals={handleMedicals}
                                      isDraggable={true}
                                    />
                                    {(getArteryLabel(operation?.body?.part) === "Left Tibioperoneal Trunk" ||
                                      getArteryLabel(operation?.body?.part) === "Right Tibioperoneal Trunk") && (
                                      <div style={{ marginBottom: 12, display: "flex", alignItems: "center", marginLeft: 16 }}>
                                        <Checkbox
                                          checked={operation?.separate_liaison || false}
                                          onChange={(e) => handleSeparateLesionChange(index, e.target.checked)}
                                        />
                                        <span style={{ marginLeft: 8 }}>Separate distinct lesion</span>
                                      </div>
                                    )}
                                  </Panel>
                                );
                              })
                            : (intaOperations.filter((r) => r?.body?.type === "vein") || []).map((operation, index) => (
                                <Panel header={getVeinLabel(operation?.body?.part)} key={`${operation?.body?.part} - ${index}`}>
                                  <VeinDetail
                                    stateErrors={stateErrors}
                                    data={operation?.body}
                                    medicals={operation?.medicals}
                                    diagnostic={operation?.diagnostic}
                                    medical={operation?.medical}
                                    handleOperation={handleSelectIcon}
                                    handleMedicals={handleMedicals}
                                    isDraggable={true}
                                  />
                                </Panel>
                              ))}
                          {[1, 2, 3, 4, 5, 6]?.map((item) => {
                            return (
                              <Panel header={"my header"} key={item} style={{ visibility: "hidden" }}>
                                <div></div>
                              </Panel>
                            );
                          })}
                          <div ref={collapseEndRef}></div>
                        </Collapse>
                      }
                    </ScrollWrapper>
                  </CardWhiteBlock>
                </>
              ) : (
                <>
                  {/* Start AI optimization tab */}
                  <CardWhiteBlock
                    varient={"default"}
                    other={"half-height"}
                    cardContainerStyle={{
                      height: "calc(100% - 1rem - 20px)",
                    }}
                    extraStyle={{
                      padding: "1.5rem 1.5rem",
                      backgroundColor: "transparent",
                    }}
                    title={
                      <div
                        className="pannel-title"
                        style={{
                          marginTop: "1.5rem",
                          marginLeft: "-12px",
                          display: "flex",
                        }}
                      >
                        <Icon type="appstore" theme="twoTone" twoToneColor="#EE5396" />
                        <span
                          style={{
                            marginLeft: "8px",
                            fontSize: "18px",
                            fontWeight: "normal",
                          }}
                        >
                          AI OPTIMIZATION
                        </span>
                      </div>
                    }
                  >
                    <div style={{ height: "calc(100% - 120px)" }}>
                      <div className="subDataTable">
                        <div
                          className="subDataTable__title"
                          style={{
                            padding: "0",
                            borderTop: "1px solid #dbe3ee",
                          }}
                        >
                          {getTitle()}
                        </div>
                      </div>
                      <ExtendDataTableNew
                        disableHeader={true}
                        onClickColumn={(index) => setSelectedColumn(index)}
                        widths={["calc(20% + 3rem)", "calc(20% + 3rem)", "50%"]}
                        title={getTitle()}
                        ListActiveHover={dataShowResultHover}
                        ListActiveHover2={dataHoverGroup2}
                        highlights={highlights}
                        data={(TestNewAILocal || []).map((opt, index) => ({
                          key: `${opt?.vessel}`,
                          vessel: (
                            <div className="vitals-first-col">
                              <div className="icon-wrapper">
                                <Checkbox
                                  checked={opt?.active}
                                  onChange={() => handleCheckboxChange(index)}
                                  className={highlights.includes(opt?.vessel) && !opt?.active ? "highlight-checkbox" : ""}
                                />
                              </div>
                              <div className="ant-time-picker">{opt?.vessel}</div>
                            </div>
                          ),
                          criteria: (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              {(opt?.criteria || []).map((row, indexCri) => (
                                <div
                                  key={`${indexCri}-${opt?.vessel}`}
                                  style={{ display: "flex", flexDirection: "row", height: 40, alignItems: "center" }}
                                >
                                  {disableCheckAtherectomy && row?.name == "Atherectomy Required" && checkActiveDissable(opt?.vessel) ? (
                                    <>
                                      {" "}
                                      <div className="icon-wrapper">
                                        <Checkbox checked={false} disabled={true} onChange={() => handleCheckboxChange(index, indexCri)} />
                                      </div>
                                      <div className="ant-time-picker disable" disabled={true} style={{ marginLeft: 20, color: "grey" }}>
                                        {row?.name}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <div className="icon-wrapper">
                                        <Checkbox checked={row?.active} onChange={() => handleCheckboxChange(index, indexCri)} />
                                      </div>
                                      <div className="ant-time-picker" style={{ marginLeft: 20 }}>
                                        {row?.name}
                                      </div>
                                    </>
                                  )}
                                </div>
                              ))}
                            </div>
                          ),
                          procedure_plan: (
                            <ArteryDetailNewForAI
                              toolsOpt={renderProcedure(index, opt)}
                              details={[]}
                              handleOperation={() => {}}
                              handleMedicals={() => {}}
                            />
                          ),
                        }))}
                        options={["vessel", "criteria", "procedure_plan"]}
                      />
                    </div>
                    <div
                      style={{
                        height: 60,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        flexDirection: "row",
                      }}
                    >
                      <div style={{ width: "calc(100% - 100px)" }}>
                        {(reasons || []).map((reason, index) => (
                          <p style={{ fontWeight: "bold" }}>{`${index + 1}. ${reason}`}</p>
                        ))}
                        <p>
                          {(activeCombination === -1 || activeCombination === 0) && (
                            <>
                              {(optimizedCombination || [])
                                .map((combination) => combination?.cpt_code?.code)
                                .filter(Boolean)
                                .join(", ")}
                              <br />
                              Reimburse Amount:
                              {(optimizedCombination || [])
                                .map((combination) => combination?.amount)
                                .filter(Boolean)
                                .join(", ")}
                              <br />
                            </>
                          )}
                          {activeCombination !== -1 && activeCombination !== 0 && (
                            <>
                              {combinations?.[activeCombination]?.combination
                                ?.map((item) => item)
                                .filter(Boolean)
                                .join(", ")}
                            </>
                          )}
                          Total Reimburse Amount: {totalReimbursement} <br />
                          Total Cost: {totalCost}
                        </p>
                      </div>
                      <div style={{ width: 100, display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <span
                          style={{
                            width: "100%",
                            color: "#007bff",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: "bold",
                            textAlign: "right",
                          }}
                        >
                          {renderPrice()}
                        </span>
                      </div>
                    </div>
                    <div style={{ height: 60, display: "flex", alignItems: "flex-start", justifyContent: "flex-end", width: "100%" }}>
                      {isEditingAi === false && (
                        <>
                          <button
                            disabled={activeCombination === -1 || activeCombination === 0}
                            onClick={() => {
                              if (activeCombination >= -1) {
                                setActiveCombination(activeCombination - 1);
                              }
                            }}
                            className="common-btn"
                            style={{ marginRight: 20, width: 154 }}
                          >
                            Previous Suggestion
                          </button>
                          <button
                            disabled={combinations && activeCombination === combinations.length - 1 ? true : false}
                            onClick={() => {
                              if (activeCombination == -1) {
                                setActiveCombination(activeCombination + 2);
                              } else {
                                setActiveCombination(activeCombination + 1);
                              }
                            }}
                            className="common-btn"
                          >
                            Next Suggestion
                          </button>
                        </>
                      )}
                      {isEditingAi === true && (
                        <button className="common-btn" onClick={saveAiChoice} disabled={is_locked}>
                          Calculate
                        </button>
                      )}
                    </div>
                  </CardWhiteBlock>
                </>
              )}
            </div>
          </DndProvider>
        </div>
      </div>
      {isSidebar === true && (
        <IntaOperativeSideBar
          ref={sidebarRef}
          dataOnchange={dataOnchange}
          resource={StaticResource}
          isShow={isSidebar}
          handleCloseSidebar={handleCloseSidebar}
          appointment={dataCPT}
        />
      )}
    </div>
  );
};

export default IntaOperative;
